
<img class="hero-sphere-3" [src]="icons.sphere3" alt="">
<img class="hero-sphere-1" [src]="icons.sphere1" alt="">
<!-- <img class="whatsapp-icon" [src]="icons.whatsapp" alt=""
        [ngStyle]=" {
          'position': 'fixed',
          'right': '48px',
          'bottom': '25px',
          'z-index': 1000
        }"> -->
<img class="hero-sphere-2" [src]="icons.sphere3" alt="">
<img class="hero-sphere-4" [src]="icons.sphere3" alt="">
<img class="hero-sphere-5" [src]="icons.sphere1" alt="">
<img class="hero-sphere-6" [src]="icons.sphere1" alt="">
<img class="green-lines-1" src="./../../../assets/images/green-lines.svg" alt="" srcset="">
<img class="green-lines-2" src="./../../../assets/images/green-lines.svg" alt="" srcset="">
